module.exports = __webpack_public_path__ + "img/customer_tag_3.2cb45e44.webp";